var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_4424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5008 4H19.3342V5.33333H21.3342V20H2.66749V5.33333H4.66749V4H2.50082C2.34498 4.0026 2.19118 4.03588 2.0482 4.09794C1.90522 4.15999 1.77587 4.24961 1.66753 4.36166C1.55919 4.47371 1.47399 4.60601 1.41679 4.751C1.35959 4.89599 1.33151 5.05083 1.33416 5.20667V20.1267C1.33151 20.2825 1.35959 20.4373 1.41679 20.5823C1.47399 20.7273 1.55919 20.8596 1.66753 20.9717C1.77587 21.0837 1.90522 21.1733 2.0482 21.2354C2.19118 21.2974 2.34498 21.3307 2.50082 21.3333H21.5008C21.6567 21.3307 21.8105 21.2974 21.9534 21.2354C22.0964 21.1733 22.2258 21.0837 22.3341 20.9717C22.4425 20.8596 22.5277 20.7273 22.5849 20.5823C22.6421 20.4373 22.6701 20.2825 22.6675 20.1267V5.20667C22.6701 5.05083 22.6421 4.89599 22.5849 4.751C22.5277 4.60601 22.4425 4.47371 22.3341 4.36166C22.2258 4.24961 22.0964 4.15999 21.9534 4.09794C21.8105 4.03588 21.6567 4.0026 21.5008 4Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 9.33301H6.66732V10.6663H5.33398V9.33301Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 9.33301H10.6673V10.6663H9.33398V9.33301Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 9.33301H14.6673V10.6663H13.334V9.33301Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 9.33301H18.6673V10.6663H17.334V9.33301Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 12.667H6.66732V14.0003H5.33398V12.667Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 12.667H10.6673V14.0003H9.33398V12.667Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 12.667H14.6673V14.0003H13.334V12.667Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 12.667H18.6673V14.0003H17.334V12.667Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 16H6.66732V17.3333H5.33398V16Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 16H10.6673V17.3333H9.33398V16Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 16H14.6673V17.3333H13.334V16Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 16H18.6673V17.3333H17.334V16Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.66634C6.84348 6.66634 7.01305 6.5961 7.13807 6.47108C7.2631 6.34605 7.33333 6.17649 7.33333 5.99967V1.99967C7.33333 1.82286 7.2631 1.65329 7.13807 1.52827C7.01305 1.40325 6.84348 1.33301 6.66667 1.33301C6.48986 1.33301 6.32029 1.40325 6.19526 1.52827C6.07024 1.65329 6 1.82286 6 1.99967V5.99967C6 6.17649 6.07024 6.34605 6.19526 6.47108C6.32029 6.5961 6.48986 6.66634 6.66667 6.66634Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 6.66634C17.5095 6.66634 17.6791 6.5961 17.8041 6.47108C17.9291 6.34605 17.9993 6.17649 17.9993 5.99967V1.99967C17.9993 1.82286 17.9291 1.65329 17.8041 1.52827C17.6791 1.40325 17.5095 1.33301 17.3327 1.33301C17.1559 1.33301 16.9863 1.40325 16.8613 1.52827C16.7363 1.65329 16.666 1.82286 16.666 1.99967V5.99967C16.666 6.17649 16.7363 6.34605 16.8613 6.47108C16.9863 6.5961 17.1559 6.66634 17.3327 6.66634Z",
    fill: "#79AC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 4H15.3327V5.33333H8.66602V4Z",
    fill: "#79AC78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_4424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.598be4b846e9b03ca6f9d94baf4c6db5.svg";
export { ForwardRef as ReactComponent };